import {InfiniteData} from '@tanstack/query-core';
import flatten from 'lodash/flatten';
import {parse} from 'qs';
import {qs} from 'url-parse';
import {selectListAndRestData} from '../../../common/selectListAndRestData';
import {
  SearchAutoComplete,
  SearchKeyword,
  SearchKeywordQuery,
} from '../../../graphql/generated/types';
import {TranslateKey} from '../../../locale/type';
import {SEARCH_DEFAULT_CATEGORY_UID} from '../constant';
import {AutoCompleteKeywordInfo} from '../type';
import {getMatchedKeyword} from '../util/getMatchedKeyword';

// TODO: BFF에서 처리해주면 좋을 거 같다.
export function selectCategoryTabItemList(data?: SearchKeyword) {
  return data?.categoryOptionList?.map(option => ({
    id: option.param,
    text: option.name,
    // @TODO: API에서 번역키를 내려주는지에 대한 확인 필요.
    textTKey: option.name as TranslateKey,
    href: `${location.pathname}?${qs.stringify({
      ...parse(location.search, {ignoreQueryPrefix: true}),
      categoryUid: String(option.param),
    })}`,
  }));
}

export function selectCurrentSearchKeywordCategoryUid(data?: SearchKeyword) {
  return data?.selectedCategoryOption.param || SEARCH_DEFAULT_CATEGORY_UID;
}

export function selectAutoCompleteCustomProps(
  infiniteData?: InfiniteData<SearchKeywordQuery>
) {
  const data = selectListAndRestData<SearchKeywordQuery, 'searchKeyword'>(
    'searchKeyword',
    infiniteData
  );
  if (!data) {
    return;
  }
  return {
    page_category_filter: data.selectedCategoryOption.name,
    page_sort: data.selectedSortOption.name,
    completed: data.showOnlyComplete ? 'y' : 'n',
    search_result_term: data.keyword,
  } as const;
}

export function selectSearchKeyword(
  infiniteData?: InfiniteData<SearchKeywordQuery>
) {
  if (!infiniteData) return undefined;
  const list = flatten(
    infiniteData.pages.map(page => {
      if (!page.searchKeyword) return undefined;
      return page.searchKeyword.list;
    })
  );
  return {
    ...infiniteData.pages[infiniteData.pages.length - 1].searchKeyword,
    list,
  } as SearchKeyword;
}

export function selectAutoCompleteKeywordInfoList({
  list,
  searchKeyword,
}: {
  list?: SearchAutoComplete['list'];
  searchKeyword: string;
}): AutoCompleteKeywordInfo[] | undefined {
  return list?.map(item => {
    const matchedKeyword = getMatchedKeyword({
      searchKeyword,
      autoCompleteKeyword: item.text,
    });

    return {
      autoCompleteKeyword: item.text,
      matchedSearchKeyword: {
        matchedKeyword: matchedKeyword ? matchedKeyword : '',
        restKeyword: matchedKeyword
          ? item.text.replace(matchedKeyword, '')
          : item.text,
      },
      url: item.url,
    };
  });
}
